module.exports = __webpack_public_path__ + "img/401.918aaa52.jpg";